export const isGuid = (utmQuery: string): boolean => {
  if (!utmQuery) {
    return false; // Handle null or empty input
  }

  // Check for standard GUID format (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  if (guidRegex.test(utmQuery)) {
    return true;
  }

  // Check for 47-character GUID format (XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX-XX)
  const guid47Regex = /^[0-9A-F]{2}(-[0-9A-F]{2}){15}$/;
  return guid47Regex.test(utmQuery);
};
